module.exports = __webpack_public_path__ + "static/media/in-the-beginning-was-the-word_2.44342bf2.jpg";